export default __webpack_public_path__ + "static/media/621ad34f493f2d7158ef7704c74b7e001599837982204.1fbefda2.webp";